import { RoutesConst } from "../routeConstant";
// /games
var mainGameURL = "".concat(RoutesConst.ROOT).concat(RoutesConst.GAMES);
/** Урлы роутов для игр */
export var RoutesListGame = {
    // #region All
    /** Список ближайших игр всех юзеров */
    getGamesList: function () { return mainGameURL; },
    /** Список всех игр всех юзеров */
    getAllGamesList: function () { return "".concat(mainGameURL, "/").concat(RoutesConst.ALL); },
    /** Список прошлых игр всех юзеров */
    getPastGamesList: function () { return "".concat(mainGameURL, "/").concat(RoutesConst.PAST); },
    // #endregion
    // #region Personal
    /** Список ближайших игр авторизованного юзера */
    getPersonalGamesList: function () { return "".concat(mainGameURL, "/").concat(RoutesConst.PERSONAL); },
    /** Список всех игр авторизованного юзера */
    getPersonalAllGamesList: function () {
        return "".concat(mainGameURL, "/").concat(RoutesConst.PERSONAL, "/").concat(RoutesConst.ALL);
    },
    /** Список прошлых игр авторизованного юзера */
    getPersonalPastGamesList: function () {
        return "".concat(mainGameURL, "/").concat(RoutesConst.PERSONAL, "/").concat(RoutesConst.PAST);
    },
    // #endregion
    /** Детали игры */
    getGameDetails: function (gameId) { return "".concat(mainGameURL, "/").concat(gameId); },
    /** Редактирование игры */
    getGameEdit: function (gameId) {
        return "".concat(mainGameURL, "/").concat(gameId, "/").concat(RoutesConst.EDIT);
    },
    /** Добавление игры */
    getGameAdd: function () { return "".concat(mainGameURL, "/").concat(RoutesConst.ADD); },
    // #region Actions
    /** Принятие приглашения */
    getGameAcceptInvite: function (gameId) { return "".concat(mainGameURL, "/accept/").concat(gameId); },
    /** Отклонение приглашения */
    getGameRejectInvite: function (gameId) { return "".concat(mainGameURL, "/reject/").concat(gameId); },
    /** Принятие запроса на участие */
    getGameJoinAllow: function (gameId) { return "".concat(mainGameURL, "/allow/").concat(gameId); },
    /** Отклонение запроса на участие */
    getGameJoinDecline: function (gameId) { return "".concat(mainGameURL, "/decline/").concat(gameId); },
    // #endregion
};
